import { Label } from '@/components/base/label'
import type { SwitchProps } from '@/components/base/switch'
import { Switch } from '@/components/base/switch'
import { useRoomStoreActions } from '@/stores/room'
import { useId } from 'react'

type SwitchRemoveBackgroundNoiseProps = Omit<
  SwitchProps,
  'checked' | 'id' | 'onCheckedChange'
> & {
  memberId: string
  removeBackgroundNoise: boolean
}

export const SwitchRemoveBackgroundNoise = ({
  memberId,
  removeBackgroundNoise,
  ...props
}: SwitchRemoveBackgroundNoiseProps) => {
  const { setRemoveBackgroundNoise } = useRoomStoreActions()

  const removeBackgroundNoiseId = useId()

  const handleChange = (value: boolean) => {
    // TODO: Implement the logic to handle the change of remove background noise setting
    setRemoveBackgroundNoise({ memberId, value })
    // update background noise setting
    // fallback to previous value if the update fails
  }

  return (
    <>
      <Label htmlFor={removeBackgroundNoiseId}>Remove Background Noise</Label>
      <Switch
        id={removeBackgroundNoiseId}
        checked={removeBackgroundNoise}
        onCheckedChange={handleChange}
        {...props}
      />
    </>
  )
}
